

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.CSVConfigurations = (function () {

    function CSVConfigurations(fileType) {

        this.className ='csvConfigurations';

        App.Forms.DataImport = App.Forms.DataImport || {};
        App.Forms.DataImport.CSVConfigurations = this;


        this.setFileType = function(type) {
            fileType = type;
        };

        this.createBaseStructure = function() {

            var titleContainer = document.createElement('div');
            var title = document.createElement('h1');
            title.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.csv.title');
            titleContainer.className = 'MonetUIFormSectionTitle';

            titleContainer.appendChild(title);

            this.rootEl = document.createElement('div');
            this.rootEl.className = this.className;

            this.checksContainer = document.createElement('div');
            this.checksContainer.className = 'checksContainer';

            this.delimiterContainer = document.createElement('div');
            this.delimiterContainer.className = 'delimiterContainer';

            this.actionsContainer = document.createElement('div');
            this.actionsContainer.className = 'actionsContainer';

            this.previewContainer = document.createElement('div');
            this.previewContainer.className = 'previewContainer';

            this.optionsField = new Monet.UI.Fields.Render({
                label: '',
                type: 'RADIO_GROUP',
                defaultValue: 'csv',
                fieldDomains: [
                    {description: Monet.I18n.getResourcesByKey('Greenmile.DataImport.delimitedFormat'), value:'csv', id: 'delimitedFormat'},
                    {description: Monet.I18n.getResourcesByKey('Greenmile.DataImport.fixedWidth'), value:'txt', id: 'fixedWidth'}
                ]
            }, 'FileTypeOptions').render();

            var options = this.optionsField.rootEl.querySelectorAll('.radio_group_item > input[type="radio"]');
            var fn = function(e) {
                this.setFileTypeConfigs(e.target.value);
            }.bind(this);

            for(var i = 0; i < options.length; i++) {
                options[i].addEventListener('click', fn);
            }

            this.rootEl.appendChild(titleContainer);
            this.rootEl.appendChild(this.optionsField.rootEl);
            this.checksContainer.appendChild(this.delimiterContainer);
            this.checksContainer.appendChild(this.actionsContainer);
            this.rootEl.appendChild(this.checksContainer);
            this.rootEl.appendChild(this.previewContainer);

        };

        this.show = function(value, showCache) {

            this.rootEl = App.Forms.DataImport.CSVConfigurations.rootEl;
            this.value = value;

            if(!this.rootEl || !showCache) {
                this.render();
                Greenmile.DataImport.Utils.getPreview(10, function(lines) {
                    if(lines ) {
                        this.renderPreview(this.processPreview(lines));
                    }
                }.bind(this));
            }

            var container = document.querySelector('.form_DataImport');
            container.innerHTML = '';
            container.parentNode.setAttribute('screen', this.className);

            container.appendChild( this.rootEl );
        };

        this.getSelectedDelimiters = function() {
            var delimiters = [];
            for (var key in this.checks) {

                if(['consecutive', 'hasHeader'].indexOf(key) === -1) {
                    if(this.checks[key].field.getValue()) {
                        this.checks[key].value = key;
                        delimiters.push(this.checks[key]);
                    }
                }
            }

            return delimiters;
        };

        this.processPreview = function(data) {

            var delimiters = this.getSelectedDelimiters().map(function(i) {
                    var symbol = i.symbol;
                    if(i.label === 'Greenmile.DataImport.other') {
                        symbol = symbol();
                    }
                    return symbol;

                }).join(''),
                regex = '['+delimiters +']',
                textQualifier = this.textQualifiers.input.options[this.textQualifiers.input.selectedIndex].innerHTML.trim();

            if (this.checks.consecutive.field.getValue()) {
                regex += '+';
            }

            if (textQualifier) {
                regex += '(?=(?:[^'+ textQualifier + ']|'+ textQualifier + '[^'+ textQualifier + ']*'+ textQualifier + ')*$)';
            }

            var result = {
                header: null,
                lines: [] //line should has columns
            };

            this.previewData = data;

            for(var i = 0, length = data.length; i < length; i++) {

                var columns = data[i].split(new RegExp(regex, 'g'));
                result.lines.push( { columns: columns } );
            }

            if ( this.checks.hasHeader.field.getValue() ) {
                result.header = result.lines.shift();
            }

            return result;

        };

        /**
         * processedData is something like { header: [], lines: [ { columns:[] } ] }
         * @type {function(this:Greenmile.DataImport.CSVConfigurations)}
         */
        this.renderPreview = function(processedData) {
            var table = document.createElement('table'),
                header = processedData.header,
                lines = processedData.lines;

            table.className = 'tablePreview';

            var oldGrid = this.previewContainer.querySelector('.tablePreview');
            if(oldGrid) {
                this.previewContainer.removeChild(oldGrid);
            }

            var createLine = function(columns, className) {
                var  cell, line;

                line = document.createElement('tr');
                line.className = className;

                for (var i = 0, length = columns.length; i < length; i++) {
                    cell = document.createElement('th');
                    cell.className = 'cell';
                    cell.innerHTML = columns[i];
                    cell.setAttribute('title', columns[i]);
                    line.appendChild(cell);
                }

                return line;
            };

            if (header) {
                table.appendChild(createLine(header.columns, 'line header'));
            }

            for(var j = 0, length = lines.length; j < length; j++) {

                table.appendChild(createLine(lines[j].columns, 'line'));
            }

            this.previewContainer.appendChild(table);
        }.bind(this);

        this.goToMapScreen = function() {

            fileType = this.optionsField.getValue();

            if ( fileType.toUpperCase() === 'CSV' ) {

                new Greenmile.DataImport.MappingScreenCsv(this.getPreviewData()).show(this.value).setViewValue();

            } else {

                Greenmile.DataImport.Utils.getPreview(1, function(line) {
                    if(line ) {
                        new Greenmile.DataImport.MappingScreenPlanText({
                            header:[],
                            firstLine:[line]
                        }).show(this.value).setViewValue();
                    }
                }.bind(this));

            }
        }.bind(this);

        this.getPreviewData = function() {
            var data = {
                header:[],
                firstLine:[]
            };
            var table = this.previewContainer.querySelector('table');
            var header = table.querySelectorAll('.line.header .cell');
            var firstLine =   table.querySelectorAll('tr:nth-child('+ (header.length ? 2 : 1) + ') .cell');

            for(var i = 0; i < firstLine.length; i++) {
                var headerValue = i.toString();
                if (header && header.length && header[i]) {
                    headerValue = '('+ (i+1)+ ') ' + header[i].innerHTML;
                }
                data.header.push({value: headerValue, path: headerValue, fileColumnNum: i + 1  });
                data.firstLine.push(firstLine[i].innerHTML);
            }

            return data;
        };

        this.createButtons = function() {
            var container = document.createElement('div');
            container.className = 'MonetUIFormSectionButton';

            this.btnMapping = new Monet.UI.Fields.Render({
                customJavaScript: this.goToMapScreen,
                label: 'Grid.pagination.next',
                type: 'BUTTON'
            }).render();

            this.btnMapping.setId('goToMapScreen');

            container.appendChild(this.btnMapping.rootEl);

            return container;
        };

        this.getValue = function() {

            var delimiters = this.getSelectedDelimiters().map(function(e){
                return e.value.toUpperCase();
            });

            var value = {
                delimiters: delimiters,
                textQualifiers:[this.textQualifiers.getValue()],
                hasHeader:  this.checks.hasHeader.field.getValue()
            };

            if (delimiters.indexOf('OTHER') !== -1) {
                value.otherDelimiter = this.checks.other.field.rootEl.querySelector('.other-delimiter-value').value;
            }

            return value;
        }.bind(this);

        this.setValue = function(value) {
            this.value = value;
            if(this.value) {
                var delimiters = this.value.delimiters,
                    textQualifiers = this.value.textQualifiers,
                    type = this.value.fileType.toLowerCase();
                App.Forms.DataImport.EntityList.entityPicklist.setValue(this.value.rootEntity);
                this.textQualifiers.setValue((textQualifiers && textQualifiers.length ? textQualifiers[0]: ''));
                for(var i in delimiters) {
                    this.checks[delimiters[i].toLowerCase()].field.setChecked(true);
                }

                if(this.value.hasHeader) {
                    this.checks.hasHeader.field.setChecked(true);
                }

                if(delimiters && delimiters.indexOf('OTHER') !== -1){
                    this.checks.other.field.rootEl.querySelector('.other-delimiter-value').value = this.value.otherDelimiter;
                }

                this.setFileTypeConfigs(type === 'csv'? type : 'txt');

            }

        };

        this.setFileTypeConfigs = function(selectedOption) {
            this.optionsField.setValue(selectedOption);
            this.checksContainer.style.display = 'block';
            var scope = this;

            var enableDisable = function(fn) {

                scope.textQualifiers[fn]();
                for(var i in this.checks) {
                    this.checks[i].field[fn]();
                }
                var other = scope.checks.other.field.rootEl.querySelector('.other-delimiter-value');
                other.value = other.value || '';

                other.disabled = (fn === 'disable');

            }.bind(this);

            if(selectedOption === 'txt') {
                enableDisable('disable');
            } else {
                enableDisable('enable');
            }
        };


        this.render = function() {

            this.createBaseStructure();

            this.checks = {
                tab: {label: 'Greenmile.DataImport.tab', symbol: '\t'},
                semicolon: {label: 'Greenmile.DataImport.semicolon', symbol: ';'},
                space: {label: 'Greenmile.DataImport.space', symbol:  ' '},
                comma: {label: 'Greenmile.DataImport.comma', symbol:  ','},
                other: {label: 'Greenmile.DataImport.other', symbol: function() {
                    return this.checks.other.field.rootEl.querySelector('.other-delimiter-value').value;
                }.bind(this) },
                consecutive: {label: 'Greenmile.DataImport.consecutive', symbol:  '+'},
                hasHeader: {label: 'Greenmile.DataImport.header'}
            };

            var callback = function() {
                this.renderPreview(this.processPreview(this.previewData));
            }.bind(this);

            for(var key in this.checks) {
                var option = this.checks[key];
                option.field = new Monet.UI.Fields.Render({
                    label: option.label,
                    name: key,
                    type: 'CHECKBOX'
                }, 'CSVConfigurations').render();

                if (['consecutive', 'hasHeader'].indexOf(key) !== -1) {
                    this.actionsContainer.appendChild(option.field.rootEl);
                } else {
                    this.delimiterContainer.appendChild(option.field.rootEl);
                }
                option.field.input.addEventListener('change', callback);
            }

            var input = document.createElement('input');
            input.className = 'other-delimiter-value';
            input.addEventListener('keyup', callback);

            var other = this.delimiterContainer.querySelector('#CSVConfigurations_other');
            other.appendChild(input);

            var fieldDomains = [
                {description: ' ', value: 'NONE'},
                {description: ' \' ', value: 'QUOTE'},
                {description: ' " ', value: 'DOUBLE_QUOTES'}
            ];

            this.textQualifiers = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.TextQualifiers',
                type: 'PICKLIST',
                fieldDomains: fieldDomains

            }).render();

            this.textQualifiers.removeOption(0);
            this.textQualifiers.setId('TextQualifiers');
            this.textQualifiers.setSelectedValue('DOUBLE_QUOTES');
            this.textQualifiers.input.addEventListener('change', callback);

            this.actionsContainer.appendChild(this.textQualifiers.rootEl);

           this.rootEl.appendChild(  this.createButtons() );

            if(this.value) {
                this.setValue(this.value);
            } else {
                this.setFileTypeConfigs(fileType.toLowerCase());
            }
           return this.rootEl;
        };

    }

    return CSVConfigurations;
}());
